!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.mainDetails = this.querySelector("[data-details]"), this.triggers = this.querySelectorAll("[data-tab-trigger]"), 
      this.tabPanelsContainer = this.querySelector("[data-tab-panels]"), this.triggers.forEach(t => {
        t.addEventListener("click", t => this.onTriggerClick(t));
      });
    }
    onTriggerClick(t) {
      const e = t.currentTarget.dataset.tabTrigger, a = this.tabPanelsContainer.querySelector(`details[data-tab-id="${e}"]`);
      this.openTab(a);
    }
    openTab(t) {
      t && t.setAttribute("open", "");
    }
  }
  customElements.get("product-details") || customElements.define("product-details", t);
}();